import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import ClickOutside from 'vuetify/lib/directives/click-outside';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VNavigationDrawer, {
    directives: [{
      def: ClickOutside,
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideDrawer,
      expression: "clickOutsideDrawer"
    }],
    attrs: {
      fixed: "",
      bottom: "",
      right: "",
      width: "35%",
      temporary: ""
    },
    model: {
      value: _vm.drawer,
      callback: function callback($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }, [_c("div", {
    staticClass: "drawer"
  }, [_c("section", {
    staticClass: "drawer-header"
  }, [_c("div", {
    staticClass: "drawer-title"
  }, [_c(VBtn, {
    staticClass: "primary",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.close
    }
  }, [_c(VIcon, {
    attrs: {
      dark: ""
    }
  }, [_vm._v("mdi-close")])], 1), _c("h2", [_vm._v(_vm._s(_vm.order.reference_order.shorterReference()) + " to approve")])], 1)]), _c(VStepper, {
    key: _vm.steps.length,
    attrs: {
      vertical: ""
    },
    model: {
      value: _vm.currentStep,
      callback: function callback($$v) {
        _vm.currentStep = $$v;
      },
      expression: "currentStep"
    }
  }, [_vm._l(_vm.steps, function (step) {
    var _vm$order$importer, _vm$order$importer2, _vm$itemsProvenanceNo, _vm$itemsProvenanceFr;
    return [_c("div", {
      key: "step_".concat(step.id)
    }, [_c(VStepperStep, {
      attrs: {
        step: step.id,
        complete: _vm.currentStep > step.id,
        rules: step.rules,
        editable: ""
      }
    }, [_vm._v(" " + _vm._s(step.title) + " "), _c("small", [_vm._v(_vm._s(step.inf))])]), step.key === "terms" ? _c(VStepperContent, {
      attrs: {
        step: step.id
      }
    }, [!_vm.isChangingTerms ? _c("div", {
      staticClass: "text-left"
    }, [_c("div", {
      staticClass: "text-sm"
    }, [_vm._v("Do you agree with the payment terms currently defined?")]), _c("strong", [_vm._v("« " + _vm._s(_vm.termsLabel) + " »")]), _c("a", {
      staticClass: "ml-2 text-sm",
      attrs: {
        href: "#"
      },
      on: {
        click: _vm.toggleTerms
      }
    }, [_vm._v("Change")]), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        "data-cy": "validate-order-drawer-continue-btn"
      },
      on: {
        click: _vm.confirmStep
      }
    }, [_vm._v(" Continue ")])], 1)]) : _c("div", {
      staticClass: "form-terms"
    }, [_c(VForm, {
      model: {
        value: _vm.form.valid,
        callback: function callback($$v) {
          _vm.$set(_vm.form, "valid", $$v);
        },
        expression: "form.valid"
      }
    }, [_c(VSelect, {
      attrs: {
        items: _vm.listTerms,
        "item-value": "id",
        "item-text": "name",
        placeholder: "Select a terms",
        rules: [_vm.rules.mustNotBeEmpty]
      },
      model: {
        value: _vm.form.terms,
        callback: function callback($$v) {
          _vm.$set(_vm.form, "terms", $$v);
        },
        expression: "form.terms"
      }
    }), _c(VBtn, {
      attrs: {
        color: "primary",
        disabled: !_vm.form.terms
      },
      on: {
        click: function click() {
          _vm.toggleTerms();
          _vm.confirmStep();
        }
      }
    }, [_vm._v(" Continue ")])], 1)], 1)]) : _vm._e(), step.key === "supplier_prices" ? _c(VStepperContent, {
      attrs: {
        step: step.id
      }
    }, [_c("div", {
      staticClass: "text-left"
    }, [_c("div", {
      staticClass: "mb-4"
    }, [_vm._v(" Some items in this order do not have supplier prices configured. "), _vm.canManageSupplierPrices ? [_vm._v(" Please add the required supplier prices before continuing. ")] : [_vm._v(" Please contact an administrator to add the required supplier prices before continuing. ")], _vm.canBypassItemsWithoutSupplierPrices ? [_vm._v(" Or bypass this validation if needed. ")] : _vm._e()], 2), _c(VDataTable, {
      staticClass: "elevation-0",
      attrs: {
        headers: _vm.missingSupplierPricesHeaders,
        items: _vm.itemsMissingSupplierPrices,
        dense: "",
        "hide-default-footer": "",
        "disable-pagination": ""
      },
      scopedSlots: _vm._u([{
        key: "item.sku",
        fn: function fn(_ref) {
          var _item$wine$naming_dat, _item$wine;
          var item = _ref.item;
          return [_vm._v(" " + _vm._s((_item$wine$naming_dat = (_item$wine = item.wine) === null || _item$wine === void 0 || (_item$wine = _item$wine.naming_data) === null || _item$wine === void 0 ? void 0 : _item$wine.sku) !== null && _item$wine$naming_dat !== void 0 ? _item$wine$naming_dat : "-") + " ")];
        }
      }, {
        key: "item.name",
        fn: function fn(_ref2) {
          var _item$wine$display_na, _item$wine2;
          var item = _ref2.item;
          return [_vm._v(" " + _vm._s((_item$wine$display_na = (_item$wine2 = item.wine) === null || _item$wine2 === void 0 ? void 0 : _item$wine2.display_name) !== null && _item$wine$display_na !== void 0 ? _item$wine$display_na : "-") + " ")];
        }
      }, {
        key: "item.actions",
        fn: function fn(_ref3) {
          var _ref4, _item$suppliersPrices, _ref5, _item$suppliersPrices2;
          var item = _ref3.item;
          return [_vm.canManageSupplierPrices && item.isDirectWinery ? _c(VBtn, {
            staticClass: "dfwa-btn --small-2",
            class: ((_ref4 = (_item$suppliersPrices = item.suppliersPricesList) !== null && _item$suppliersPrices !== void 0 ? _item$suppliersPrices : item.supplierPricesList) !== null && _ref4 !== void 0 ? _ref4 : []).length === 0 ? "secondary" : "highlight",
            attrs: {
              rounded: true
            },
            on: {
              click: function click($event) {
                var _item$wine$id_wine, _item$wine3;
                return _vm.$emit("openSupplierPrices", (_item$wine$id_wine = (_item$wine3 = item.wine) === null || _item$wine3 === void 0 ? void 0 : _item$wine3.id_wine) !== null && _item$wine$id_wine !== void 0 ? _item$wine$id_wine : item.id_wine);
              }
            }
          }, [_c("i", {
            staticClass: "fas fa-search-dollar mr-1"
          }), _vm._v(" Supplier prices ( "), _c("span", {
            staticClass: "bold"
          }, [_vm._v(" " + _vm._s(((_ref5 = (_item$suppliersPrices2 = item.suppliersPricesList) !== null && _item$suppliersPrices2 !== void 0 ? _item$suppliersPrices2 : item.supplierPricesList) !== null && _ref5 !== void 0 ? _ref5 : []).length) + " ")]), _vm._v(" ) ")]) : _vm._e()];
        }
      }], null, true)
    }), _c("div", {
      staticClass: "mt-6"
    }, [_vm.canBypassItemsWithoutSupplierPrices && _vm.itemsMissingSupplierPrices.some(function (x) {
      var _x$supplierPricesList, _x$suppliersPricesLis;
      return ((_x$supplierPricesList = x.supplierPricesList) === null || _x$supplierPricesList === void 0 ? void 0 : _x$supplierPricesList.length) === 0 || ((_x$suppliersPricesLis = x.suppliersPricesList) === null || _x$suppliersPricesLis === void 0 ? void 0 : _x$suppliersPricesLis.length) === 0;
    }) ? _c(VCheckbox, {
      staticClass: "mt-0",
      attrs: {
        "hide-details": "auto",
        label: "Bypass supplier price validation and continue. Note: items without supplier prices will be excluded from purchase orders."
      },
      model: {
        value: _vm.bypassWithoutSupplierPrice,
        callback: function callback($$v) {
          _vm.bypassWithoutSupplierPrice = $$v;
        },
        expression: "bypassWithoutSupplierPrice"
      }
    }) : _vm._e()], 1), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        disabled: !_vm.bypassWithoutSupplierPrice && _vm.itemsMissingSupplierPrices.some(function (x) {
          var _ref6, _x$supplierPricesList2;
          return ((_ref6 = (_x$supplierPricesList2 = x.supplierPricesList) !== null && _x$supplierPricesList2 !== void 0 ? _x$supplierPricesList2 : x.suppliersPricesList) === null || _ref6 === void 0 ? void 0 : _ref6.length) === 0;
        })
      },
      on: {
        click: function click($event) {
          return _vm.confirmStep();
        }
      }
    }, [_vm._v(" Continue ")])], 1)], 1)]) : _vm._e(), step.key === "importer" ? _c(VStepperContent, {
      attrs: {
        step: step.id
      }
    }, [_c("div", {
      staticClass: "text-left"
    }, [!_vm.isEditingImporter ? [_c("strong", [_vm._v(" « " + _vm._s(((_vm$order$importer = _vm.order.importer) === null || _vm$order$importer === void 0 ? void 0 : _vm$order$importer.id) > 0 ? _vm.order.importer.name : "No importer") + " » ")]), _vm.canEditImporter ? _c("a", {
      staticClass: "ml-2 text-sm",
      attrs: {
        href: "#"
      },
      on: {
        click: function click() {
          _vm.isEditingImporter = true;
        }
      }
    }, [_vm._v(" Change ")]) : _vm._e()] : _c("div", {
      staticClass: "d-flex"
    }, [_c(VAutocomplete, {
      attrs: {
        items: _vm.importersAvailable,
        "item-value": "id",
        "item-text": "name",
        "return-object": "",
        label: "Importer",
        "hide-details": "auto"
      },
      model: {
        value: _vm.importerSelectorSelected,
        callback: function callback($$v) {
          _vm.importerSelectorSelected = $$v;
        },
        expression: "importerSelectorSelected"
      }
    }), _c("div", {
      staticClass: "mt-3"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small",
      attrs: {
        disabled: !_vm.importerSelectorSelected
      },
      on: {
        click: _vm.saveChangeImporter
      }
    }, [_vm._v(" Save ")])], 1)], 1), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        disabled: !((_vm$order$importer2 = _vm.order.importer) !== null && _vm$order$importer2 !== void 0 && _vm$order$importer2.id),
        "data-cy": "validate-order-drawer-importer-continue-btn"
      },
      on: {
        click: function click($event) {
          return _vm.confirmStep();
        }
      }
    }, [_vm._v(" Continue ")])], 1)], 2)]) : _vm._e(), step.key === "prevent_invoice" ? _c(VStepperContent, {
      attrs: {
        step: step.id
      }
    }, [_c("div", {
      staticClass: "text-left"
    }, [_c("div", {
      staticClass: "d-flex"
    }, [_c(VSwitch, {
      staticClass: "mt-0",
      attrs: {
        "false-value": true,
        "true-value": false,
        readonly: _vm.isContainerOrderOrLinkedToContainerOrder,
        "hide-details": "auto"
      },
      model: {
        value: _vm.form.isPreventInvoice,
        callback: function callback($$v) {
          _vm.$set(_vm.form, "isPreventInvoice", $$v);
        },
        expression: "form.isPreventInvoice"
      }
    }), !!_vm.form.isPreventInvoice ? _c("span", {
      staticClass: "text-red text-bold"
    }, [_vm._v(" Order confirmation : The platform WILL NOT GENERATE FRENCH INVOICE for this order ")]) : _c("span", {
      staticClass: "text-green text-bold"
    }, [_vm._v(" FR Invoice : The platform will generate a french invoice for this order ")])], 1), _vm.isContainerOrderOrLinkedToContainerOrder ? _c("div", {
      staticClass: "mt-1"
    }, [_c(VAlert, {
      staticClass: "--small",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "orange",
        text: ""
      }
    }, [_c("div", [_vm._v("Forced value due to container order setting")])])], 1) : _vm._e(), _vm.hasWarningItemsProvenanceAboutInvoice ? _c("div", {
      staticClass: "mt-3"
    }, [_vm.form.isPreventInvoice && ((_vm$itemsProvenanceNo = _vm.itemsProvenanceNotFromOrder) === null || _vm$itemsProvenanceNo === void 0 ? void 0 : _vm$itemsProvenanceNo.length) > 0 ? _c(VAlert, {
      staticClass: "--small",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "orange",
        text: ""
      }
    }, [_c("div", [_vm._v(" Some items are not linked to a previous invoice, which may result in accounting issues. "), _c("br"), _vm._v(" Please ensure that the order complies with all applicable laws. ")]), _vm._l(_vm.itemsProvenanceNotFromOrder, function (item) {
      return _c("div", {
        key: "alert-provenance-invoice-" + item.id_item
      }, [_vm._v(" - " + _vm._s("".concat(item.quantity, " b. of ").concat(item.wine.naming_data.sku)) + " "), _c("span", {
        staticClass: "text-smaller text-italic"
      }, [_vm._v(" (" + _vm._s(_vm.wineNaming(_vm.$whitelabel, item.wine.naming_data, true, true)) + ") ")])]);
    })], 2) : !_vm.form.isPreventInvoice && ((_vm$itemsProvenanceFr = _vm.itemsProvenanceFromOrder) === null || _vm$itemsProvenanceFr === void 0 ? void 0 : _vm$itemsProvenanceFr.length) > 0 ? _c(VAlert, {
      staticClass: "--small",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "orange",
        text: ""
      }
    }, [_c("div", [_vm._v(" Some items are already linked to a previous invoice, which may result in accounting issues. "), _c("br"), _vm._v(" Please ensure that the order complies with all applicable laws. ")]), _vm._l(_vm.itemsProvenanceFromOrder, function (item) {
      return _c("div", {
        key: "alert-provenance-invoice-" + item.id_item
      }, [_vm._v(" - " + _vm._s("".concat(item.quantity, " b. of ").concat(item.wine.naming_data.sku)) + " "), _c("span", [_vm._v(" (" + _vm._s(_vm.wineNaming(_vm.$whitelabel, item.wine.naming_data, true, true)) + ") ")])]);
    })], 2) : _vm._e()], 1) : _vm._e(), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        "data-cy": "validate-order-drawer-importer-continue-btn"
      },
      on: {
        click: function click($event) {
          return _vm.confirmStep();
        }
      }
    }, [_vm._v(" Continue ")])], 1)])]) : _vm._e(), step.key === "synthesis" ? _c(VStepperContent, {
      attrs: {
        step: step.id
      }
    }, [_c("div", {
      staticClass: "text-left"
    }, [_vm.form.terms > 1 ? [_vm._v(" Payment terms : "), _c("strong", [_vm._v(_vm._s(_vm.termsLabel))]), _vm._v(" . ")] : [_vm._v(" The payment of the order will be done "), _c("strong", [_vm._v("upon receipt")]), _vm._v(" . ")], _vm.isInvalidForm ? _c("div", {
      staticClass: "errorLabel"
    }, [_vm._v(" Some required data is missing in a previous step. Please verify and correct it. ")]) : _vm._e(), _c("div", {
      staticClass: "mt-4"
    }, [_c("span", {
      staticClass: "text-bold"
    }, [_vm._v(" Will not notify the customer by automatic platform mail ")])]), _vm.hasImporter ? _c("div", {
      staticClass: "mt-4"
    }, [_c("div", {
      staticClass: "text-smaller text-italic"
    }, [_vm._v("Mail title : Order has been validated")]), _c("div", {
      staticClass: "d-flex align-center"
    }, [_c(VSwitch, {
      staticClass: "mt-0",
      attrs: {
        "hide-details": "auto",
        disabled: !_vm.importerSelectedHasMail
      },
      model: {
        value: _vm.isSendNotificationMailsToImporter,
        callback: function callback($$v) {
          _vm.isSendNotificationMailsToImporter = $$v;
        },
        expression: "isSendNotificationMailsToImporter"
      }
    }), !_vm.isSendNotificationMailsToImporter ? [_vm.importerSelectedHasMail ? _c("span", {
      staticClass: "text-red"
    }, [_vm._v(" WILL NOT send any email to the IMPORTER ")]) : _c("span", {
      staticClass: "text-red text-italic"
    }, [_vm._v(" The importer has no mail configured ")])] : _c("span", {
      staticClass: "text-green"
    }, [_vm._v(" Will send an email to the IMPORTER with the invoice attached ")])], 2)]) : _vm._e(), _vm.hasWarningItemsProvenanceAboutInvoice ? _c(VAlert, {
      staticClass: "--small mt-3",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "orange",
        text: ""
      }
    }, [_vm._v(" It appears there might be a potential accounting issue with some items. "), _c("br"), _vm._v(' Please review the "Invoice / Order Confirmation" step for verification. ')]) : _vm._e(), _vm.itemsMissingSupplierPrices.length > 0 ? _c(VAlert, {
      staticClass: "--small mt-3",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "orange",
        text: ""
      }
    }, [_vm._v(" Automatic purchase order generation is currently disabled and will not be triggered. ")]) : _vm._e(), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        disabled: _vm.isInvalidForm,
        loading: _vm.isValidatingOrder,
        "data-cy": "validate-order-drawer-save-btn"
      },
      on: {
        click: _vm.validate
      }
    }, [_vm._v(" Save ")])], 1)], 2)]) : _vm._e()], 1)];
  })], 2)], 1), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };